import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlashBriefingComponent } from './components/flash-briefing/flash-briefing.component';
import { FlashBriefingSelectionComponent } from './components/flash-briefing-selection/flash-briefing-selection.component';
import { ReactiveFormsModule } from '@angular/forms';
import { EtxIconsRegistryService } from '../../../../shared/src/lib/components/etx-icons/etx-icons-registry.service';
import {
  etxIconAdd,
  etxIconDownload,
  etxIconFavorites,
  etxIconShare
} from '../../../../shared/src/lib/components/etx-icons/etx-icons.model';
import { SharedModule } from '@purplefront/shared';
import { PlaylistDataAccessModule } from '@purplefront/playlist/data-access';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    PlaylistDataAccessModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  declarations: [FlashBriefingComponent, FlashBriefingSelectionComponent],
  exports: [FlashBriefingComponent, FlashBriefingSelectionComponent]
})
export class FlashBriefingUiModule {
  constructor(private _etxIconsRegistry: EtxIconsRegistryService) {
    this._etxIconsRegistry.registerIcons([etxIconAdd, etxIconDownload, etxIconShare, etxIconFavorites]);
  }
}
